import { makeStyles } from '@material-ui/core'

const useStyle = makeStyles((theme) => ({
  container: {
    height: '100%',
    justifyContent: 'center',
    flexDirection: 'column',
    display: 'flex',
  },
}))

export default useStyle
